module.exports = __webpack_public_path__ + "static/img/2.85389cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/2.png
// module id = yrL/
// module chunks = 0